import { render } from "./FinalSection.vue?vue&type=template&id=5adc2785&ts=true"
import script from "./FinalSection.vue?vue&type=script&lang=ts"
export * from "./FinalSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__